import { StrictMode } from 'react'
import { createRoot, hydrateRoot } from 'react-dom/client'
import { createRouter, RouterProvider } from '@tanstack/react-router'
import { HelmetProvider } from '@saas-pages/shared/public/seo'
import { routeTree } from '@/app/routeTree'
import { hitMetrika, initMetrika } from '@saas-pages/shared/public/runtime'
import { I18nProvider } from '@/shared/i18n'
import branding from '../branding.config'
import '@/shared/styles/index.css'

initMetrika(branding.metrikaId)

const router = createRouter({ routeTree })

router.subscribe('onResolved', (event) => {
  if (!event.fromLocation || !event.hrefChanged) {
    return
  }
  hitMetrika(window.location.href)
})

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

const rootElement = document.getElementById('root')
if (!rootElement) {
  throw new Error('Root element #root not found in the document.')
}

const app = (
  <StrictMode>
    <HelmetProvider>
      <I18nProvider>
        <RouterProvider router={router} />
      </I18nProvider>
    </HelmetProvider>
  </StrictMode>
)

if (rootElement.hasChildNodes()) {
  hydrateRoot(rootElement, app)
} else {
  createRoot(rootElement).render(app)
}
